export interface CongressionalDistrict {
  state: string;
  district: string | null; // null = at-large (single district state)
  label: string;
}

const rawData: Array<[string, number[]]> = [
  ["Alabama", [1, 2, 3, 4, 5, 6, 7]],
  ["Alaska", []],
  ["Arizona", [1, 2, 3, 4, 5, 6, 7, 8, 9]],
  ["Arkansas", [1, 2, 3, 4]],
  ["California", Array.from({ length: 52 }, (_, i) => i + 1)],
  ["Colorado", [1, 2, 3, 4, 5, 6, 7, 8]],
  ["Connecticut", [1, 2, 3, 4, 5]],
  ["Delaware", []],
  ["District of Columbia", []],
  ["Florida", Array.from({ length: 28 }, (_, i) => i + 1)],
  ["Georgia", [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]],
  ["Hawaii", [1, 2]],
  ["Idaho", [1, 2]],
  ["Illinois", Array.from({ length: 17 }, (_, i) => i + 1)],
  ["Indiana", [1, 2, 3, 4, 5, 6, 7, 8, 9]],
  ["Iowa", [1, 2, 3, 4]],
  ["Kansas", [1, 2, 3, 4]],
  ["Kentucky", [1, 2, 3, 4, 5, 6]],
  ["Louisiana", [1, 2, 3, 4, 5, 6]],
  ["Maine", [1, 2]],
  ["Maryland", [1, 2, 3, 4, 5, 6, 7, 8]],
  ["Massachusetts", [1, 2, 3, 4, 5, 6, 7, 8, 9]],
  ["Michigan", Array.from({ length: 13 }, (_, i) => i + 1)],
  ["Minnesota", [1, 2, 3, 4, 5, 6, 7, 8]],
  ["Mississippi", [1, 2, 3, 4]],
  ["Missouri", [1, 2, 3, 4, 5, 6, 7, 8]],
  ["Montana", [1, 2]],
  ["Nebraska", [1, 2, 3]],
  ["Nevada", [1, 2, 3, 4]],
  ["New Hampshire", [1, 2]],
  ["New Jersey", Array.from({ length: 12 }, (_, i) => i + 1)],
  ["New Mexico", [1, 2, 3]],
  ["New York", Array.from({ length: 26 }, (_, i) => i + 1)],
  ["North Carolina", Array.from({ length: 14 }, (_, i) => i + 1)],
  ["North Dakota", []],
  ["Ohio", Array.from({ length: 15 }, (_, i) => i + 1)],
  ["Oklahoma", [1, 2, 3, 4, 5]],
  ["Oregon", [1, 2, 3, 4, 5, 6]],
  ["Pennsylvania", Array.from({ length: 17 }, (_, i) => i + 1)],
  ["Rhode Island", [1, 2]],
  ["South Carolina", [1, 2, 3, 4, 5, 6, 7]],
  ["South Dakota", []],
  ["Tennessee", [1, 2, 3, 4, 5, 6, 7, 8, 9]],
  ["Texas", Array.from({ length: 38 }, (_, i) => i + 1)],
  ["Utah", [1, 2, 3, 4]],
  ["Vermont", []],
  ["Virginia", [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]],
  ["Washington", [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]],
  ["West Virginia", [1, 2]],
  ["Wisconsin", [1, 2, 3, 4, 5, 6, 7, 8]],
  ["Wyoming", []],
  ["Puerto Rico", []],
];

export const usaDistrictsMap: Map<string, CongressionalDistrict[]> = new Map();

rawData.forEach(([state, districts]) => {
  if (districts.length === 0) {
    usaDistrictsMap.set(state, [
      { state, district: null, label: "At-Large" },
    ]);
  } else {
    usaDistrictsMap.set(
      state,
      districts.map((d) => ({
        state,
        district: String(d),
        label: `District ${d}`,
      }))
    );
  }
});

export const getDistrictsForState = (stateName: string): CongressionalDistrict[] => {
  return usaDistrictsMap.get(stateName) ?? [];
};
